import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

export function AnnouncementBar() {
  const { t } = useI18n();
  return (
    <div
      data-testid="announcement-bar"
      className="w-full bg-wafa-sunshine text-wafa-deep"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-center gap-1 px-4 py-2 text-center text-xs sm:flex-row sm:gap-3 sm:text-sm">
        <span className="font-medium">{t.announcement.text}</span>
        <Link
          to="/tools/pdpl-readiness-check"
          data-testid="announcement-cta"
          className="font-semibold underline-offset-4 hover:underline"
        >
          {t.announcement.cta}
        </Link>
      </div>
    </div>
  );
}
